'use client'

import CoachingPage from '@/components/organisms/sportPage/coachingPage'

const PLAYTOMIC_ACADEMY = 'https://app.playtomic.io/tenants/325afbbf-2acc-473b-b93c-0dd30b4adff3/academy'

const FALLBACK_COACHES = [
  {
    name: 'Julian Lasarte',
    position: 'Tennis Director',
    bio: 'Julian leads the tennis program at Mahima Bali and brings international coaching experience, energy, and professionalism to the courts. His coaching style focuses on technical development, tactical understanding, movement, and confidence building.',
    bio2: 'Julian works with players of all levels — from beginners learning the basics to experienced players wanting to sharpen their competitive performance. His sessions are dynamic, motivating, and fully adapted to the goals of each player.',
    focusAreas: [
      { label: 'Forehand and backhand technique' },
      { label: 'Serve and return consistency' },
      { label: 'Court positioning and tactical awareness' },
      { label: 'Mental confidence and match preparation' },
      { label: 'Movement efficiency and footwork' },
      { label: 'Technical development and stroke mechanics' },
    ],
  },
]

const FALLBACK_CLASSES = [
  {
    title: 'Private Lesson',
    description: 'One-on-one coaching with Julian, fully tailored to your level and goals. The most direct way to improve technique, tactics, and match confidence.',
    price: '',
    duration: '60 min',
    playtomicUrl: 'https://playtomic.io',
  },
  {
    title: 'Group Lesson',
    description: 'Small group sessions covering stroke mechanics, drills, and live ball play. Open to all levels — a great way to improve while enjoying the social side of the game.',
    price: '',
    duration: '90 min',
    playtomicUrl: 'https://playtomic.io',
  },
  {
    title: 'Junior Coaching',
    description: 'Structured sessions for younger players focused on building technique, movement, and a love for tennis in a fun and encouraging environment.',
    price: '',
    duration: '60 min',
    playtomicUrl: 'https://playtomic.io',
  },
]

const DEFAULT_INTRO =
  "Train and play tennis in one of Bali's most unique performance environments. Mahima combines premium cushioned hard courts, experienced coaching, wellness, recovery, and community into one complete experience in the heart of Ubud — the only standalone ITF-standard tennis facility in the area."

const TennisCoachingPage = ({ coachingAPI, footerAPI, settingAPI }) => {
  const hero = coachingAPI?.hero || {}
  const cta = coachingAPI?.cta || {}
  const coaches = (coachingAPI?.coaches?.length ? coachingAPI.coaches : FALLBACK_COACHES).map((c) => ({
    ...c,
    focusAreas: (c.focusAreas || []).map((f) => f.label).filter(Boolean),
  }))
  const classes = (coachingAPI?.classes?.length ? coachingAPI.classes : FALLBACK_CLASSES).map((c) => ({
    ...c,
    url: c.playtomicUrl && c.playtomicUrl !== 'https://playtomic.io' ? c.playtomicUrl : PLAYTOMIC_ACADEMY,
  }))
  const bookUrl = cta.playtomicUrl || PLAYTOMIC_ACADEMY

  return (
    <CoachingPage
      footerAPI={footerAPI}
      settingAPI={settingAPI}
      eyebrow={hero.label || 'Tennis coaching in Sayan, Ubud'}
      heading={hero.heading || 'Tennis at Mahima'}
      intros={[hero.intro || (!coachingAPI ? DEFAULT_INTRO : null), hero.intro2]}
      classesHeading={coachingAPI?.classesHeading || 'Classes & Sessions'}
      classes={classes}
      classesImage={coachingAPI?.classesImage}
      classesImageAlt="Tennis coaching at Mahima, Sayan, Ubud"
      coachesHeading={coachingAPI?.teamHeading}
      coaches={coaches}
      bookUrl={bookUrl}
      cta={{
        heading: cta.heading || 'Ready to elevate your tennis?',
        description: cta.description || 'Book a session on our ITF-standard courts in Sayan, Ubud. All levels welcome.',
        url: bookUrl,
        label: 'Book a class on Playtomic',
      }}
    />
  )
}

export default TennisCoachingPage
